/**
 *
 * Asynchronously loads the component for Analytics
 *
 */

 import loadable from '../../utils/loadable';

 export default loadable(() => import('./index'));